module.exports = __webpack_public_path__ + "static/other/desert_terraform.a3d5c5d1.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/desert_terraform.json
// module id = 2249
// module chunks = 0